import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './scss/SkeletonSidebar.scss';

const SkeletonSidebar = () => {
    return (
        <div className="skeleton-sidebar">
            {[1, 2, 3, 4].map((section) => (
                <div key={section} className="skeleton-sidebar-section">
                    <div className="skeleton-sidebar-header">
                        <Skeleton circle height={30} width={30} />
                        <Skeleton height={20} width={100} />
                    </div>
                    <div className="skeleton-sidebar-items">
                        {[1, 2, 3].map((item) => (
                            <div key={item} className="skeleton-sidebar-item">
                                <Skeleton circle height={18} width={18} />
                                <Skeleton height={16} width={120} />
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SkeletonSidebar;
